<template>
  <!-- <section class="start__screen-module"> -->

  <div class="container">

    <div class="rcv__heading-v1">
      <h1>{{ ballotData.heading }}</h1>

    </div>
    <div class="rcv__canditate-row">

      <div class="rcv__canditate-col" v-for="(candidate, index) in ballotData.listOfAnimals" :key="index">
        <div class="rcv__canditate-card">
          <div class="rcv__canditate-profile">
          
            <div :class="['rcv__candidate-avatar', getCandidateColorClass(candidate.color)]">
              <img :src="candidate.image" :alt="candidate.altText" width="90" height="90">
            </div>
          </div>
          <div class="rcv__canditate-details">
            <h3>{{candidate.animalCandidateName}}</h3>
            <p>{{candidate.description}}</p>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!-- </section>  -->
</template>
<script>
export default {
  name: "MeetheCandidatesComponent",
  props: {
    ballotData: {
      type: Object,
      required: false
    }
  },
  data() {
    return {};
  },

  computed: {

  },

  methods: {
    getCandidateColorClass(color) {
      
    const colorClassMap = {
      "#fdf751": "rcv__candidate-color-1",
      "#221649": "rcv__candidate-color-2",
      "#4ba3b7": "rcv__candidate-color-3",
      "#ed7aca": "rcv__candidate-color-4",
      "#eb5534": "rcv__candidate-color-5",
      "#367d54": "rcv__candidate-color-6"
    };

    return colorClassMap[color] || "rcv__candidate-color-6"; // default class
  }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/MeetTheCandidatesComponent.vue